const createUid = () => {
    const key = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_-';
    /**
     * 28位
     */
    let ramStr = parseInt(Math.random() * 268435455).toString(2);

    /* eslint-disable */
    /**
     * 44位
     */
    let mtimeStr = new Date().getTime().toString(2);

    while (ramStr.length < 28) ramStr = `0${ramStr}`;
    while (mtimeStr.length < 44) mtimeStr = `0${mtimeStr}`;
    const binaryStr = ramStr + mtimeStr;

    let outStr = '';

    for (let i = 0; i < 12; i++) {
        outStr += key.charAt(parseInt(binaryStr.substr(i * 6, 6), 2));
    }

    return outStr;
};

export default createUid;


// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.component.util/app/lib/gid.js